import React, { useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import ProductCard from "./ProductCard";
import SubTiltle from "./../Layout/SubTitle";
import UseGetAllFavorite from "../../CustomHooks/Favorite/UseGetAllFavorite";


const CardProductContainer = ({ title, btntitle, pathlink, products }) => {
  const [favList, allFavorites,loading] = UseGetAllFavorite()
  return (
    <Container>
      <SubTiltle title={title} btntitle={btntitle} pathlink={pathlink} />
      <Row className="my-2 d-flex justify-content-center">
        {products
          ? products.map((item, index) => {
            return <ProductCard key={index} item={item} favList={favList}/>;
          })
          : null}
      </Row>
    </Container>
  );
};

export default CardProductContainer;
